import { Grid, List, ListItemButton } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import {
  WsElementWithPopOver,
  WsIconText,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { SmallBoxWithRadius } from '../../features/candidates/utils/CandidateHelper';
import ErrorLogger from '../../providers/ErrorLogger';

interface CommunicationLinkTypes {
  label: string;
  onClick: (arg1?: string, arg2?: string) => void;
  icon: React.ReactElement;
}
interface IEmailsProps {
  icon: React.ReactElement;
  emailOrPhNo: string;
  objects: CommunicationLinkTypes[];
  textColor?: WsTypoColors;
  onActionClick?: (args1: string, args2: string) => void;
  type?: string;
}

const CommunicationLinks = ({
  icon,
  emailOrPhNo,
  objects,
  textColor,
  onActionClick,
  type,
}: IEmailsProps) => {
  const handleIconClick = (value) => {
    if (onActionClick) {
      onActionClick(value, emailOrPhNo);
    }
  };

  return (
    <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
      <WsElementWithPopOver
        element={
          <SmallBoxWithRadius>
            <Grid
              className={type ? (type === 'email' ? 'contact-email' : 'contact-phone') : 'contact'}
              item
              container
              xs={12}
              alignItems="center"
              columnGap={0.5}
            >
              {icon}
              <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.PRIMARY}>
                {emailOrPhNo}
              </WsTypography>
            </Grid>
          </SmallBoxWithRadius>
        }
      >
        <List dense={true} sx={{ cursor: 'pointer' }}>
          {objects.map((item, index) => (
            <ListItemButton
              key={index}
              onClick={() => {
                if (onActionClick) {
                  onActionClick(item.label, emailOrPhNo);
                }
              }}
            >
              <WsIconText
                textCursor="pointer"
                onClick={(value) => handleIconClick(value)}
                text={item.label}
                icon={item.icon}
                textColor={index === 4 ? WsTypoColors.SECONDARY : textColor}
              />
            </ListItemButton>
          ))}
        </List>
      </WsElementWithPopOver>
    </ErrorBoundary>
  );
};

export default CommunicationLinks;
